'use client';

import { usePathname } from 'next/navigation';
import { ClientOnly } from '@/components/ClientOnly';
import SuperAdminContent from './SuperAdminContent';
import { isSuperAdminAuthPath, tabFromPath } from './routes';

function LoadingShell() {
  return (
    <div className="sa-layout flex items-center justify-center min-h-[100dvh]">
      <p className="text-sm text-ink-500">A carregar painel...</p>
    </div>
  );
}

export default function SuperAdminRoot({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();

  if (isSuperAdminAuthPath(pathname)) {
    return <>{children}</>;
  }

  const activeTab = tabFromPath(pathname);

  return (
    <ClientOnly fallback={<LoadingShell />}>
      <SuperAdminContent activeTab={activeTab} />
    </ClientOnly>
  );
}
